// extracted by mini-css-extract-plugin
export default {"productGrid":"A0-z","centerLink":"B0-z","productSection":"C0-z","item":"D0-z","ctaButton":"E0-z"};